<template>
    <section class="app-breadcrumbs">
        <ul>
            <li class="app-breadcrumbs__item">
                <button :class="['app-breadcrumbs__context-button', showBreadcrumbs ? 'has-breadcrumbs' : '']">
                    <app-icon-button
                        :class="['app-switcher__button--svg', 'app-breadcrumbs__context-button__icon']"
                        :prototype="{
                            icon: require('../assets/icons/icon-chevron-down.svg')
                        }"
                    />
                    <app-icon-button
                        :prototype="currentApp"
                    />
                    <span class="app-breadcrumbs__context-button__label">{{ currentApp.name }}</span>
                </button>
                <button v-if="showContextSwitcherButton && showBreadcrumbs" :class="['app-breadcrumbs__context-switcher-button', showAppSwitcher ? 'active' : null]" @click="() => tools.actions.toggleContextSwitcher()">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="#010202" d="M21.248 10.171h-2.29v-2.29a.75.75 0 0 0-.75-.75h-2.29V4.84a.75.75 0 0 0-.75-.75H2.752a.75.75 0 0 0-.75.75v8.238c0 .414.336.75.75.75h2.09c.071 0 .135-.022.2-.04v2.33c0 .414.336.75.75.75h2.09c.071 0 .135-.022.2-.04v2.33c0 .414.336.75.75.75h12.417a.75.75 0 0 0 .75-.75V10.92a.75.75 0 0 0-.751-.749zM5.042 7.881v4.489c-.065-.018-.129-.04-.2-.04h-1.34V5.59h10.917v1.54H5.792a.751.751 0 0 0-.75.751zm3.04 3.04v4.489c-.065-.018-.129-.04-.2-.04h-1.34V8.631h10.917v1.54H8.832a.75.75 0 0 0-.75.75zm12.416 7.488H9.582v-6.738h10.917v6.738z"/></svg>
                </button>
            </li>
            <li class="app-breadcrumbs__item" v-for="(breadcrumb, index) in data" v-if="data.length && !showAppSwitcher && showBreadcrumbs">
                <button :title="breadcrumb.title" class="app-breadcrumbs__button" v-if="!Array.isArray(breadcrumb)" @click="() => updateBreadcrumbs(breadcrumb.i)">{{ concat(breadcrumb.title) }}</button>
                <template v-if="Array.isArray(breadcrumb)">
                    <button class="app-breadcrumbs__dropdown_toggle" @click="toggleDropdown">
                        <img class="app-breadcrumbs__dots" :src="require('../assets/icons/icon-dots.svg')" alt="" />
                    </button>
                    <ul ref="dropdown" :class="['app-breadcrumbs__dropdown', dropdownVisible ? 'active' : null]">
                        <li class="app-breadcrumbs__dropdown__item" v-for="subMenuBreadcrumb in breadcrumb">
                            <button class="app-breadcrumbs__dropdown__item__button" @click="() => updateBreadcrumbs(subMenuBreadcrumb.i)">
                                {{ subMenuBreadcrumb.title }}
                            </button>
                        </li>
                    </ul>
                </template>
                <svg class="app-breadcrumbs__arrow" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                viewBox="0 0 15 22" enable-background="new 0 0 15 22" xml:space="preserve">
                <polygon points="1.411,21.907 0.528,21.498 5.396,11 0.528,0.502 1.411,0.093 6.469,11 "/>
                </svg>
            </li>
        </ul>
    </section>
</template>

<script>
    // import Ps from 'perfect-scrollbar';

    export default {
        name: 'app-breadcrumbs',
        props: ['data', 'updateBreadcrumbs', 'currentApp', 'toggleDropdown', 'dropdownVisible', 'tools', 'showAppSwitcher', 'showBreadcrumbs'],
        methods: {
            concat(value) {
                const n = 25;
                return (value && value.length > n) ? value.substr(0, n-1) + '...' : value;
            },
        },
        computed: {
            showContextSwitcherButton() {
                return  this.tools.modifiers.currentMode === 'OWNER_APP_NEW_CONTEXT' ||
                        this.tools.modifiers.currentMode === 'MODIFIER_1';
            },
        },
    };
</script>

<style>
/**
 * Breadcrumbs
 */

    .app-breadcrumbs {
        display: flex;
        height: 100%;
        /*width: 100%;*/
        /*font-size:13px;*/
    }

    .app-breadcrumbs ul button {
    }

    .app-breadcrumbs > ul {
        display: flex;
    }

    .app-breadcrumbs li {
        position: relative;
    }

    .app-breadcrumbs > ul li {
    }

    ul.app-breadcrumbs__dropdown li:last-child .app-breadcrumbs__dropdown__item__button {
        border-bottom: 0;
    }

    .app-breadcrumbs__dropdown li:nth-child(odd) .app-breadcrumbs__dropdown__item__button {
        background: rgba(0,0,0,.05);
    }
    .app-breadcrumbs__dropdown li:nth-child(odd) .app-breadcrumbs__dropdown__item__button:hover {
        background: rgba(0,0,0,.15);
    }
    .app-breadcrumbs__dropdown li:nth-child(even) .app-breadcrumbs__dropdown__item__button:hover {
        background: rgba(0,0,0,.1);
    }
    .app-breadcrumbs__dropdown {
        padding: 5px;
        margin-top: -3px;
        top: 100%;
        display: none;
        position: absolute;
        /*max-width: 300px;*/
        min-width: 200px;
        background: #FFF;
        transform: translateX(-60px);
        border: 1px solid rgba(0,0,0,.1);
        border-radius: 6px;
        /*font-size: 13px;*/
        overflow-y: auto;
        max-height: 80vh;
    }

    .app-breadcrumbs__dropdown.active {
        display: block;
    }

    .app-breadcrumbs__dropdown__item__button {
        padding: 0px 8px;
        height:24px;
        width: 100%;
        /*border: 1px solid rgba(0,0,0,.1);*/
        border-radius: 5px;
        font-size: 13px;
        margin: 0;
        font-weight:600;
        color:rgba(0,0,0,0.5);
    }

    .app-breadcrumbs__dropdown__item__button:hover {
        background-color: rgba(0,0,0,.02);
    }


    /**
     * Item
     */

        .app-breadcrumbs__item {
            display: flex;
        }

        .app-breadcrumbs__item .app-breadcrumbs__button{
            font-size:13px;
            font-weight:600;
        }

        li.app-breadcrumbs__item:last-child .app-breadcrumbs__arrow {
            display: none;
        }
        li.app-breadcrumbs__item:last-child .app-breadcrumbs__button {
            opacity: 1;
        }
        li.app-breadcrumbs__item:last-child {
            opacity: 1;
            /*font-weight: 500;*/
        }

        .app-breadcrumbs__arrow {
            opacity: 0.3;
            height: 16px;
            align-self: center;
            padding-left: 6px;
        }

    /**
     * Button
     */
        .app-breadcrumbs__button,
        .app-breadcrumbs__dots {
            opacity: 0.5;
        }

        .app-breadcrumbs__button {
            height: 100%;
            padding: 0 0px;
        }

        .app-breadcrumbs__button:hover,
        .app-breadcrumbs__dots:hover {
            opacity: .5;
        }


    /**
     * Context menu
     */

         .app-breadcrumbs__context-button {
             height: 100%;
             font-weight: 600;
             color:rgba(0,0,0,0.5);
             padding: 0 30px 0 6px;
             /*width:150px;*/
             /*border-right:1px solid rgba(0,0,0,0.1);*/
         }
         .app-breadcrumbs__context-button.has-breadcrumbs:after{
             content:"";
             height:24px;
             width:1px;
             background-color:rgba(0,0,0,0.1);
             position:absolute;
             right:15px;
         }

        .app-breadcrumbs__context-button__label {
            margin-left: 10px;
            font-size:13px;
        }

        button.app-breadcrumbs__context-button__icon {
            padding: 0;
        }

    /**
     * Dots
     */

        .app-breadcrumbs__dropdown_toggle {
            display: flex;
            /*flex-flow:row nowrap;
            align-items:center;
            justify-content:center;*/
            /*padding:0;*/
        }

        .app-breadcrumbs__dots {
            width: 16px;
            position: relative;
            top:1px;
            /*margin-right: 6px;*/
        }

    /**
     * Context switcher button
     */

        .app-breadcrumbs__context-switcher-button {
            display:flex;
            flex-flow:column nowrap;
            justify-content: center;
            align-items: center;
            position: relative;
            left:-15px;
            margin-right:0px;
        }

        .app-breadcrumbs__context-switcher-button svg {
            height: auto;
            width: 24px;
            height:24px;
            opacity:0.5;
            margin-right:10px;
        }
</style>



// WEBPACK FOOTER //
// Breadcrumbs.vue?14d6c0f0